import { LocationType } from '@aviv-search/types';
import { filterLocations } from '../filterLocations/filterLocations';
export const filterPlacesIds = (locations) => {
    const placeIdsFromidSearch = filterLocations(locations, LocationType.PLACE_ID).map(({ placeId }) => placeId);
    const placeIdsFromRadiusSearch = filterLocations(locations, LocationType.RADIUS).map(({ placeId }) => placeId);
    const placeIdsFromCommuteSearch = filterLocations(locations, LocationType.COMMUTE).flatMap(({ placeIds }) => placeIds);
    return [...placeIdsFromidSearch, ...placeIdsFromRadiusSearch, ...placeIdsFromCommuteSearch];
};
